import * as React from "react";
import { useSelector } from "react-redux";
import { DateFormat } from "components/common/formatter";
import DataList from "components/MatterDetails/DataList";

import { Tile } from "components/UIComponents/Tile";
import { Checkbox } from "@progress/kendo-react-inputs";
import MatterCompletionTab from "components/MatterCompletion/MatterCompletionTab";

const MattersCompletionPage = (props) => {
  const currentMatterDetails = useSelector(
    (state) => state.mattersList?.matterViewDetails[props.reference]?.data,
  );

  return (
    <MatterCompletionTab
      matterId={currentMatterDetails?.matterId}
      matter={currentMatterDetails}
      readOnly={true}
    >
      <Tile
        heading="GDRP"
        className="px-4 pt-2 pb-3 overflow-auto flex-grow-1"
      >
        <DataList
          statusChart={true}
          valueClass={"ms-4"}
          text="Deleted:"
          value={
            <Checkbox
              readOnly={true}
              value={Boolean(currentMatterDetails?.dateDeleted)}
            />
          }
          width={"w-100"}
          keyStyles={{ minWidth: "150px" }}
        />
        <DataList
          text="Date Deleted:"
          value={DateFormat(currentMatterDetails?.dateDeleted)}
          width={"w-100"}
          valueClass={"ms-4"}
          keyStyles={{ minWidth: "150px" }}
        />
      </Tile>
    </MatterCompletionTab>
  );
};

export default MattersCompletionPage;
